module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "title",
    staticClass: "step__title"
  }, [_c('p', [_vm._v("Let’s make a number for your account")])]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "step__subtitle"
  }, [_c('p', [_vm._v("We will use the area code provided below to create your Ohana number.")])]), _vm._v(" "), _c('div', {
    ref: "form",
    staticClass: "step__form"
  }, [_c('InputField', {
    attrs: {
      "title": "PHONE AREA CODE",
      "type": "tel",
      "placeholder": "415",
      "autocomplete": "tel",
      "disabled": false,
      "errored": false,
      "validated": _vm.areaCodeValid,
      "errorMessage": "",
      "mask": "###"
    },
    model: {
      value: (_vm.areaCode),
      callback: function($$v) {
        _vm.areaCode = $$v
      },
      expression: "areaCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "button",
    staticClass: "step__button step__button--bottom"
  }, [_c('a', {
    staticClass: "button",
    class: {
      'button--disable': !_vm.areaCodeValid
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goNextStep($event)
      }
    }
  }, [_c('span', [_vm._v("Create Number")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a23ed2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/2-blocks/Step6_MakeNum.vue
// module id = 544
// module chunks = 1